import api from "../api";

export const getOrganizations = async () => {
    try {
        const response = await api.get(`mivulite/organizations`);
        return response.data;
    } catch (error) {
        console.error(error);
    }
};

export const getOrganization = async (id) => {
    try {
        const response = await api.get(`mivulite/organizations/${id}`);
        return response.data;
    } catch (error) {
        console.error(error);
    }
};

export const createOrganization = async (data) => {
    try {
        const response = await api.post(`mivulite/organizations`, data);
        return response.data;
    } catch (error) {
        console.error(error);
    }
};

export const updateOrganization = async (id, data) => {
    try {
        const response = await api.put(`mivulite/organizations/${id}`, data);
        return response.data;
    } catch (error) {
        console.error(error);
    }
};


export const assignDevicetoOrg = async (id, deviceId) => {
    try {
        const response = await api.put(`mivulite/organizations/${id}/devices/${deviceId}`);
        return response.data;
    } catch (error) {
        console.error(error);
    }
};


export const deleteOrganization = async (id) => {
    try {
        const response = await api.delete(`mivulite/organizations/${id}`);
        return response.data;
    } catch (error) {
        console.error(error);
    }
};

export const switchOrganization = async (data) => {
    try {
        const response = await api.post(`mivulite/auth/switch-org`, data);
        return response.data;
    } catch (error) {
        console.error(error);
    }
};

export const getOrganizationMembers = async (id) => {
    try {
        const response = await api.get(`mivulite/organizations/${id}/members`);
        return response.data;
    } catch (error) {
        console.error(error);
    }
};

export const inviteMember = async (id, data) => {
    try {
        const response = await api.post(`mivulite/organizations/${id}/members`, data);
        return response.data;
    } catch (error) {
        console.error(error);
    }
};

export const removeMember = async (orgId, memberId) => {
    try {
        const response = await api.delete(`mivulite/organizations/${orgId}/members/${memberId}`);
        return response.data;
    } catch (error) {
        console.error(error);
    }
};

export const updateMemberRole = async (orgId, memberId, role) => {
    try {
        const response = await api.put(`mivulite/organizations/${orgId}/members/${memberId}`, { role });
        return response.data;
    } catch (error) {
        console.error(error);
    }
};